import React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

export type TOptionType = string | boolean | number;
export type TOption<TOptionType> = {
  label?: string;
  value: TOptionType;
};

export type TSelectProps = {
  options: TOption<TOptionType>[];
} & TextFieldProps;

const Select = ({ options, ...props }: TSelectProps) => {
  return (
    <TextField select margin="dense" {...props}>
      {options.map((option, index) => (
        <MenuItem key={index} value={option.value as string}>
          {option.label || (option.value as string)}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default Select;
